import React from 'react';
import { Brain, Code, Zap, Users } from 'lucide-react';
import '../CSS/About.css'

const stats = [
  { icon: Brain, label: 'AI Projects', value: '15+' },
  { icon: Code, label: 'Automations Built', value: '25+' },
  { icon: Zap, label: 'Hours Saved', value: '5K+' },
  { icon: Users, label: 'Happy Clients', value: '10+' }
];

const About = () => (
  <section className="about-section">
    <div className="about-container">
      {/* Left side: Heading + description */}
      <div className="about-text">
        <h2 className="about-heading">About Akanksha</h2>
        <div className="gradient-divider" />
        <p className="about-description">
          I’m an AI strategist and content creator passionate about making AI accessible, impactful, and delightful for everyone.
        </p>
      </div>

      {/* Right side: Stats in 2x2 grid */}
      <div className="stats-grid">
        {stats.map((stat, i) => {
          const Icon = stat.icon;
          return (
            <div key={i} className="stat-card">
              <div className="icon-bg">
                <Icon size={24} />
              </div>
              <div className="stat-text">
                <div className="stat-value">{stat.value}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export default About;
